// extracted by mini-css-extract-plugin
export var header = "_au-0";